module.exports = __webpack_public_path__ + "static/media/sync-info-banner.1c12e01f.svg";